import BaseStore from 'hljd/esm/SearchBar/store'
import Api from '@api/experienceShop'
import { getMomentTime } from '@hlj/hlj-utils'
import { getExportUrl } from '@util'

class Store extends BaseStore {
  $listApi = Api.cooperateOrderList

  $getParams = () => {
    let { first_deduct_time, ...rest } = this.$params

    first_deduct_time = first_deduct_time
    ? first_deduct_time
    : this.$searchBar.getFieldsValue('first_deduct_time').first_deduct_time

    const params = rest
    if (first_deduct_time && first_deduct_time.length > 0) {
      params.first_deduct_time = `${getMomentTime(
        first_deduct_time,
        0,
        __FMT1__
      )} - ${getMomentTime(first_deduct_time, 1, __FMT1__)}`
    }

    return params
  }

  exportList = () => {
    const url = getExportUrl(
      '/p/wedding/Admin/APICrmBrokerage/exportCooperateOrder',
      this.$getParams()
    )
    window.open(url)
  }
}

export default Store
